<template>
  <hic-dialog title="医嘱校对" append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="35rem" @close="close">
    <el-row class="center">
      <el-switch v-model="action" active-text="提出疑问" inactive-text="校对无误" active-value="疑问" inactive-value="校对" active-color="#F56C6C" inactive-color="#67C23A" class="top-pad"></el-switch>
      <el-form class="left top-pad" ref="info" :rules="rules" :model="info" label-width="7rem">
        <!-- <el-col v-if="action == '校对'">
          <el-form-item label="校对时间：" prop="proofTime">
            <el-date-picker v-model="info.proofTime" type="datetime" size="small" placeholder="请选校对时间" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </el-col> -->
        <el-col v-if="action == '疑问'">
          <el-form-item prop="question">
            <template slot="label">
              疑问原因：
              <i class="el-icon-question" style="font-size: 5rem; color: #e4e7ed" />
            </template>
            <!-- <hic-dict-selector v-model="info.question" dict-type="ReasonList" is-enum /> -->
            <el-button v-for="item in dictEnum.ReasonList" :key="item.value" :type="item.value == info.question ? 'success' : 'primary'" @click="info.question = item.value" plain size="mini">{{ item.text }}</el-button>
            <el-input v-model="info.question" type="textarea" :rows="2" placeholder="请选择或者输入疑问原因" style="width: 100%" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <template slot="footer">
      <el-button type="info" @click.native="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      ids: Array,
    },
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        action: "校对",
        rules: {
          proofTime: [{ required: true, message: "请选校对时间", trigger: "change" }],
          question: [{ required: true, message: "请选择或输入疑问原因", trigger: "change" }],
        },
        info: {
          proofTime: this.$utils.Dt.now(),
          question: "",
        },
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum", "user"]),
    },
    methods: {
      open() {
        if (!this.$refs.info) return;
        this.$refs.info.resetFields();
        this.action = "校对";
        this.info = {
          proofTime: this.$utils.Dt.now(),
          question: "",
        };
      },
      close() {
        this.$emit("update:visible", false);
      },
      submit() {
        this.$refs.info.validate((valid) => {
          if (valid) {
            this.$emit("ok", this.action, this.ids, this.action != "疑问" ? null : this.info.question);
            this.close();
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
